import { useCallDetailsCaller } from 'features/call/call-details/hooks';
import { CallDetailsChangeNumber } from 'features/call/call-details/components';

export const CallDetailsChangeNumberContainer = () => {
  const { caller } = useCallDetailsCaller();

  return <CallDetailsChangeNumber caller={caller} />;
};
